'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesFitnessCenter = function PlacesFitnessCenter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z' })
  );
};
PlacesFitnessCenter = (0, _pure2.default)(PlacesFitnessCenter);
PlacesFitnessCenter.displayName = 'PlacesFitnessCenter';
PlacesFitnessCenter.muiName = 'SvgIcon';

exports.default = PlacesFitnessCenter;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/places/fitness-center.js
 ** module id = 2324
 ** module chunks = 0
 **/